module.exports = __webpack_public_path__ + "static/img/080_TO8_1724.5183f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/080_TO8_1724.jpg
// module id = L/nB
// module chunks = 0